export default "__VITE_ASSET__GoNmaYkP__"